import axiosClient from "./axiosClient";

// API "mua qua link TikTok" (RioHub). userId nhúng server-side vào sub_id (từ session).
const riohubAffiliateApi = {
    // Tạo affiliate link. Truyền productId (ưu tiên) hoặc productUrl.
    createAffiliateLink: ({ productId, productUrl }) =>
        axiosClient.post("riohub/affiliate/link", { productId, productUrl }),

    // Thông tin sản phẩm theo productId (1 id hoặc csv).
    getProductInfo: (productId) =>
        axiosClient.post("riohub/affiliate/product-info", { productId }),
};

export default riohubAffiliateApi;
